// extracted by mini-css-extract-plugin
export default {"config-panel":"AdminConfig_config-panel__jIdnq","disabled-label":"AdminConfig_disabled-label__b5V8T"};